// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    AddSearchHistory,
    chain,
    StartDisplayProducts,
} from "@insite/client-framework/Store/CommonHandlers/StartSearch";
import { useDisplayProducts } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { addSearchHistory } from "@keller/App/Services/AutocompleteService";
import { getSettingsCollection } from "@keller/App/Store/Selectors/SettingsSelectors";

/**
 *  XNG-Changes
 * - Use Custom addSearchHistory service
 * - Add option to the search history
 */

const XngStartDisplayProducts: typeof StartDisplayProducts = props => {
    if (props.redirectUrl) {
        return;
    }

    if (getCurrentPage(props.getState()).type === "ProductListPage" && !props.getState().pages.productList.isSearchPage) {
        return;
    }

    const [abortController, displayProducts] = useDisplayProducts();

    props.abortController = abortController;

    const showStockedItemsOnlyByDefault =
        getSettingsCollection(props.getState()).customSettings.showStockedItemsOnlyByDefault ?? false;
    const queryString = showStockedItemsOnlyByDefault
        ? `query=${encodeURIComponent(props.parameter.query)}&stockedItemsOnly=true`
        : undefined;

    props.dispatch(
        displayProducts({
            path: props.path,
            query: props.parameter.query,
            queryString,
            isSearch: true,
            relevancy: true,
        }),
    );
};

const XngAddSearchHistory: typeof AddSearchHistory = ({ redirectUrl, parameter }) => {
    const { query, searchHistoryEnabled, searchHistoryLimit, option } = parameter as any;

    if (!searchHistoryEnabled) {
        return;
    }

    option
        ? addSearchHistory(query, searchHistoryLimit, false, redirectUrl, option)
        : addSearchHistory(query, searchHistoryLimit, false, redirectUrl);
};

replaceInChain(chain, StartDisplayProducts, XngStartDisplayProducts);
replaceInChain(chain, AddSearchHistory, XngAddSearchHistory);
